import axios from "axios";
import { ECOPROTOKEN_CLAIMS, LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";
import { currentUserRoleByOrder } from "../../constants/AppMethod";
import { getLocalSessionData, getUserDataByKey, getUserSessionData } from "../Authentication/handleUserSession";

const UserActivityLogsPayload = async (currentLoggedInUserDetails) => {
    const { action, description } = currentLoggedInUserDetails;
    const isC4CAgent = getLocalSessionData(LOCALSESSIONDATAKEYS.ISC4CSERVICEAGENT)
    const searchParams = new URLSearchParams(window.location.search);
    const agentId = searchParams.get('agentid');
    const source = searchParams.get('source');
    let obj = {
        "UserId": getUserSessionData(ECOPROTOKEN_CLAIMS.USERID),
        "ADB2CId": getUserSessionData(ECOPROTOKEN_CLAIMS.ADB2CUSERID),
        "EmailId": getUserDataByKey('emailAddress', 'personal_details'),
        "RoleName": currentUserRoleByOrder(),
        "Action": action,
        "Description": description,
    };
    if (isC4CAgent)
        obj = {
            ...obj,
            "Source": source,
            "Agent": agentId
        }
    try {
        const response = await axios.get("https://api.ipify.org/?format=json");
        const res = await response;
        const IP_ADDRESS = (res?.data?.ip) ? res?.data?.ip : ""
        obj = { ...obj, "ipAddress": IP_ADDRESS }
        return obj;
    } catch (e) {
        obj = { ...obj, "ipAddress": "" }
        return obj;
    }
}

export default UserActivityLogsPayload;